export const messages = {
  errorToast: {
    regionLabel: 'הודעות שגיאה',
    close: 'סגור',
    details: 'פרטים',
    hideDetails: 'הסתר פרטים',
    copy: 'העתק',
    copied: 'הועתק',
    mail: 'שלח מייל לתמיכה',
    repeated: 'חזר {count} פעמים',
    titleOperation: 'הפעולה נכשלה',
    titleSave: 'השמירה נכשלה',
    titleLoad: 'טעינת הנתונים נכשלה',
    titleDelete: 'המחיקה נכשלה',
    titleSession: 'פג תוקף ההתחברות',
    bodyValidation: 'יש שדות חסרים או לא תקינים. בדקו את הנתונים ונסו שוב.',
    bodySession: 'התחברו מחדש כדי להמשיך.',
    bodyForbidden: 'אין לך הרשאה לפעולה זו.',
    bodyNotFound: 'הרשומה לא נמצאה.',
    bodyConflict: 'הנתונים השתנו בינתיים, רעננו ונסו שוב.',
    bodyGeneric: 'אירעה תקלה במערכת. אם היא חוזרת, פנו לתמיכה.',
    bodyNetwork: 'אין תקשורת עם השרת. בדקו את החיבור ונסו שוב.',
    mailSubject: 'LOP – תקלה: {title} ({screen})',
    mailPrompt: 'תיאור מה ניסיתי לעשות:',
    mailTruncated: '[... הטקסט קוצר - בכפתור "העתק" נמצא הטקסט המלא]',
  },
  dateInput: {
    placeholder: 'dd/mm/yyyy',
    openCalendar: 'פתח לוח שנה',
    calendar: 'לוח שנה',
    prevMonth: 'חודש קודם',
    nextMonth: 'חודש הבא',
    today: 'היום',
    invalid: 'תאריך לא תקין',
    months: {
      m1: 'ינואר', m2: 'פברואר', m3: 'מרץ', m4: 'אפריל', m5: 'מאי', m6: 'יוני',
      m7: 'יולי', m8: 'אוגוסט', m9: 'ספטמבר', m10: 'אוקטובר', m11: 'נובמבר', m12: 'דצמבר',
    },
    daysShort: { d0: 'א׳', d1: 'ב׳', d2: 'ג׳', d3: 'ד׳', d4: 'ה׳', d5: 'ו׳', d6: 'ש׳' },
    daysLong: { d0: 'ראשון', d1: 'שני', d2: 'שלישי', d3: 'רביעי', d4: 'חמישי', d5: 'שישי', d6: 'שבת' },
  },
  common: {
    loading: 'טוען...',
    back: 'חזור',
    yes: 'כן',
    no: 'לא',
    pin: 'נעץ תפריט',
    unpin: 'שחרר נעיצה',
    logout: 'התנתק',
    comingSoon: 'בקרוב',
    fromDate: 'מתאריך',
    toDate: 'עד תאריך',
    fetch: 'שלוף',
    awaitingFetchHint: 'בחרו סינון ולחצו "{fetch}" להצגת הנתונים',
    save: 'שמירה',
    saving: 'שומר...',
    cancel: 'ביטול',
    close: 'סגור',
    clear: 'נקה',
    filePicker: {
      choose: 'בחרו קובץ או גררו לכאן',
      chooseMany: 'בחרו קבצים או גררו לכאן',
      chooseFolder: 'בחרו תיקייה או גררו לכאן',
      replace: 'לחצו להחלפה',
      clear: 'הסרת הקובץ',
      filesCount: '{count} קבצים נבחרו',
    },
  },
  customization: {
    dialogTitle: 'התאמה אישית',
    tabGeneral: 'כללי',
    tabColumns: 'עמודות',
    confirmReset: 'לאפס את ההתאמה האישית למסך הזה לערכי ברירת המחדל?',
    resetDefaults: 'אפס לברירות מחדל',
    general: {
      zebra: 'צבע שורה זוגית (לסירוגין)',
      autoRefreshSeconds: 'רענון אוטומטי (שניות, 0 = ללא)',
      autoRefreshHint: 'הרענון מדלג אם יש שינויים שלא נשמרו',
    },
    columns: {
      listTitle: 'עמודות',
      searchPlaceholder: 'חיפוש עמודה',
      moveTop: 'הזז לראש',
      moveUp: 'הזז למעלה',
      moveDown: 'הזז למטה',
      moveBottom: 'הזז לסוף',
      pickAColumn: 'בחר עמודה מהרשימה כדי לערוך את ההגדרות שלה',
    },
    column: {
      subtitleNumeric: 'עמודה מספרית',
      subtitleText: 'עמודת טקסט',
      sectionFormat: 'סיכום ופורמט',
      sectionTypography: 'גופן ועיצוב',
      sectionColors: 'צבעים',
      summary: 'סיכום עמודה',
      summaryNone: 'ללא',
      format: 'פורמט תצוגה',
      formatNone: 'ללא',
      formatPlaceholder: 'לדוגמה: #,##0.00 או dd/MM/yyyy',
      formatHint: 'בסגנון אקסל. אם הפורמט לא תקין — יוצג הערך הגולמי. סימן % מכפיל ב-100.',
      font: 'גופן',
      width: 'רוחב עמודה',
      widthAuto: 'אוטומטי',
      hidden: 'הסתר עמודה',
      alignStart: 'יישור לתחילת השורה',
      alignCenter: 'מירכוז',
      alignEnd: 'יישור לסוף השורה',
      bold: 'מודגש',
      italic: 'נטוי',
      color: 'צבע',
      backgroundColor: 'צבע רקע',
      signColoring: 'צבע לפי חיובי/שלילי',
      signColoringHint: 'חיובי = ירוק, שלילי = אדום, אפס = ברירת מחדל',
      preview: 'דוגמה:',
      previewNoSample: 'אין ערך לתצוגה מקדימה',
    },
  },
  auth: {
    loginTitle: 'התחברות ל-LOP',
    email: 'אימייל',
    password: 'סיסמה',
    submit: 'המשך',
    submitting: 'מתחבר...',
    selectTenant: 'בחר חברה להתחברות:',
    invalidCredentials: 'אימייל או סיסמה שגויים',
    tooManyAttempts: 'יותר מדי ניסיונות התחברות. נסו שוב בעוד דקה.',
    tokenExpired: 'פג תוקף, נא להתחבר מחדש',
    serverDataError: 'שגיאה בנתונים מהשרת',
    unexpectedError: 'שגיאה לא צפויה',
  },
  nav: {
    appTitle: 'LOP - שיערוך קרנות',
    fundValuation: 'שיערוך קרנות',
    systemSettings: 'הגדרות מערכת',
    tenantSettings: 'הגדרות חברה',
    globalSettings: 'הגדרות גלובליות',
    funds: 'קרנות',
    bankAccounts: 'חשבונות בנק',
    banks: 'בנקים',
    systemAdmin: 'ניהול מערכת',
    users: 'משתמשים',
    roles: 'תפקידים',
  },
  dashboard: {
    title: 'ברוך הבא ל-LOP',
    subtitle: 'מערכת שיערוך קרנות נאמנות',
    pageTitle: 'לוח בקרה',
    updatedAt: 'עודכן ב-{time}',
    refresh: 'רענון',
    loadError: 'טעינת לוח הבקרה נכשלה: {message}',
    noValuationData: 'אין עדיין נתוני שיערוך',
    asOf: 'נכון ל-{date}',
    basedOnFunds: 'מבוסס על {count} קרנות',
    aumTitle: 'נכס מנוהל',
    aumTotalLabel: 'סה"כ נכס מנוהל',
    fundCountTitle: 'כמות קרנות',
    fundCountTotal: 'סה"כ {count} קרנות',
    fundCountTooltip: 'קרנות',
    valuationTitle: 'תאריכי שיערוך',
    israeliValuation: 'שיערוך ישראלים: {date}',
    foreignValuation: 'שיערוך זרים: {date}',
    dateNotSet: 'לא הוגדר',
    dayOpen: 'היום פתוח',
    dayClosed: 'היום סגור',
    dayOpenLast: 'פתיחת יום אחרונה: {value}',
    alertsTitle: 'נושאים לטיפול',
    alertsEmpty: 'אין נושאים לטיפול',
    agendaTitle: 'סדר יום',
    agendaPercent: '{percent}% הושלמו',
    readinessTitle: 'מוכנות לשיערוך',
    readinessIsraeli: 'ישראלים',
    readinessForeign: 'זרים',
    readinessNone: 'אין משימות חובה',
    trendTitle: 'מגמת נכס מנוהל',
    trendSeries: 'נכס מנוהל',
    fundTypeEtf: 'קרן סל',
    fundTypeTracker: 'קרן מחקה',
    fundTypeBuffer: 'מחקה באפר',
    fundTypeActive: 'קרן אקטיבית',
    unitMillion: 'מ׳',
    unitBillion: 'מיליארד',
    unitThousand: 'אלף',
  },
  users: {
    title: 'משתמשים',
    pageTitle: 'משתמשים',
    errorPrefix: 'שגיאה: {message}',
    neverLoggedIn: 'טרם התחבר',
    allTenants: 'כל הטננטים',
    columns: {
      userId: 'מזהה',
      email: 'דוא"ל',
      password: 'סיסמה זמנית',
      displayName: 'שם תצוגה',
      tenantId: 'חברת ניהול',
      isActive: 'פעיל',
      roleIds: 'תפקידים',
      lastLoginAt: 'התחברות אחרונה',
      createdAt: 'נוצר ב',
      lockout: 'נעילה',
    },
    lockout: {
      lockedUntil: 'נעול עד {time}',
      unlock: 'פתח נעילה',
      confirmTitle: 'פתיחת נעילת משתמש',
      confirmText: 'לפתוח את הנעילה של {email}? מונה הניסיונות הכושלים יאופס והמשתמש יוכל להתחבר מיד.',
      confirmProceed: 'פתח נעילה',
      confirmCancel: 'ביטול',
      done: 'הנעילה נפתחה',
    },
    passwordPolicyHint: 'סיסמה: לפחות 12 תווים, 3 מתוך 4 סוגי תווים (קטנות, גדולות, ספרות, סמלים), לא זהה לדוא"ל',
    validation: {
      emailRequired: 'דוא"ל נדרש',
      emailInvalid: 'דוא"ל לא תקין',
      emailTooLong: 'דוא"ל ארוך מ-640 תווים',
      passwordRequired: 'סיסמה נדרשת',
      passwordTooShort: 'סיסמה קצרה מ-12 תווים',
      displayNameRequired: 'שם תצוגה נדרש',
      displayNameTooLong: 'שם תצוגה ארוך מ-400 תווים',
      rolesRequired: 'יש לבחור לפחות תפקיד אחד',
    },
  },
  roles: {
    title: 'תפקידים',
    pageTitle: 'תפקידים',
    columns: {
      roleId: 'מזהה',
      roleName: 'שם תפקיד',
      description: 'תיאור',
      isBuiltIn: 'מובנה במערכת',
      isActive: 'פעיל',
      isSuperAdmin: 'מנהל-על',
      createdAt: 'נוצר ב',
    },
    validation: {
      roleNameRequired: 'שם תפקיד נדרש',
      roleNameTooLong: 'שם תפקיד ארוך מ-200 תווים',
      descriptionTooLong: 'תיאור ארוך מ-1000 תווים',
    },
    builtInHint: 'תפקיד מובנה — ניתן לערוך רק תיאור',
  },
  topbar: {
    organizationLabel: 'חברה:',
  },
  statusFooter: {
    env: 'סביבה',
    israeliValuationDate: 'פתיחת יום ישראלים',
    foreignValuationDate: 'פתיחת יום זרים',
    // Suffix shown after the date when that day's valuation type is `finance`
    // ("יום כספים" — balances only for the finance dept, no rate is set).
    financeDay: 'כספים',
    noValuationDate: 'טרם נקבע',
  },
  theme: {
    buttonAriaLabel: 'בחירת ערכת נושא',
    menuAriaLabel: 'ערכות נושא',
    lop: 'LOP',
    mizrahi: 'מזרחי טפחות (ברירת מחדל)',
    discount: 'דיסקונט',
    themeGroupLabel: 'ערכת נושא',
    schemeGroupLabel: 'מצב תצוגה',
    schemeLight: 'בהיר',
    schemeDark: 'כהה',
    schemeSystem: 'לפי המחשב',
  },
  banks: {
    title: 'בנקים',
    columnBankId: 'קוד בנק',
    columnBankName: 'שם הבנק',
    columnBankNameEng: 'שם באנגלית',
    columnIsActive: 'פעיל',
    columnCreditRiskTypeId: 'סיכון אשראי',
    columnCounterpartyCreditRiskTypeId: 'סיכון אשראי צד ג׳',
    columnIsForeign: 'בנק זר',
    noneOption: '— ללא —',
    errorPrefix: 'שגיאה: {message}',
    columns: {
      lendingFeeCalcTypeId: 'סוג חישוב עמלת השאלה',
    },
  },
  bankImports: {
    pageTitle: 'ניהול קליטות',
    columns: {
      importId: 'מזהה',
      importName: 'שם קליטה',
      bankId: 'בנק',
      format: 'פורמט',
      importType: 'סוג',
      sourceKind: 'מקור',
      filePattern: 'תבנית קובץ',
      splitterCode: 'מפצל',
      lastImportDate: 'תאריך קליטה אחרונה',
      lastValueDate: 'תאריך נכונות אחרונה',
      isActive: 'פעיל',
    },
  },
  foreignContracts: {
    title: 'יתרות מבנקים זרים — חוזים',
    subtitle: 'קליטת קובץ חוזים מבנק לאומי (בל"ל). מתבצעת לאחר פתיחת יום ונקלטת ישירות למלאי.',
    noAccess: 'אין לך הרשאה לצפות במסך זה',
    noDef: 'לא הוגדרה קליטת חוזים פעילה במערכת',
    file: 'קובץ חוזים (xlsx / zip)',
    valueDate: 'תאריך נכונות',
    valueDateHint: 'ריק = לפי התאריך שבקובץ',
    upload: 'קלוט',
    uploading: 'קולט...',
    sample: 'קובץ לדוגמה',
    done: 'הקליטה הסתיימה בהצלחה',
    nothingLoaded: 'לא נקלט דבר',
    valueDatesLabel: 'תאריכי נכונות',
  },
  preInventoryTable: {
    pageTitle: 'מלאי קליטה',
    columns: {
      bankId: 'בנק',
      valueDate: 'תאריך נכונות',
      acc: 'חשבון',
      balanceCode: 'קוד יתרה',
      assetId: 'מספר נייר',
      assetName: 'שם נייר',
      qty: 'ערך נקוב',
      qty4Receive: 'יתרה לקבל',
      crcyId: 'מטבע',
      rate: 'שער',
      noseType: 'מקור',
      splitterCode: 'מפצל',
    },
  },
  crud: {
    add: 'הוסף',
    save: 'שמור',
    saving: 'שומר...',
    cancel: 'בטל',
    errorPrefix: 'שגיאה: {message}',
    tooltipAdd: 'הוסף שורה',
    tooltipDelete: 'מחק שורות שנבחרו',
    tooltipSave: 'שמור שינויים',
    tooltipCancel: 'בטל שינויים',
    tooltipExport: 'יצוא ל-CSV',
    searchPlaceholder: 'חיפוש...',
    clearSearch: 'נקה חיפוש',
    loading: 'טוען נתונים',
    statusBar: {
      rows: '{count} שורות',
      filtered: 'מציג {displayed} מתוך {total}',
      selected: '{count} נבחרו',
      tooltipAdded: 'שורות שנוספו',
      tooltipModified: 'שורות שעודכנו',
      tooltipDeleted: 'שורות שנמחקו',
      saveCustomization: 'שמירת התאמה אישית',
    },
    toast: {
      customizationSaved: 'ההתאמה האישית נשמרה',
    },
  },
  // AgGrid built-in texts (overlays + column filter menu), fed via localeText in LopAgGrid.
  gridLocale: {
    noRowsToShow: 'אין שורות להצגה',
    noMatchingRows: 'לא נמצאו שורות מתאימות',
    loadingOoo: 'טוען...',
    loadingError: 'שגיאה בטעינה',
    filterOoo: 'סינון...',
    searchOoo: 'חיפוש...',
    selectAll: 'בחר הכל',
    blanks: '(ריקים)',
    equals: 'שווה ל',
    notEqual: 'שונה מ',
    contains: 'מכיל',
    notContains: 'לא מכיל',
    startsWith: 'מתחיל ב',
    endsWith: 'מסתיים ב',
    blank: 'ריק',
    notBlank: 'לא ריק',
    lessThan: 'קטן מ',
    greaterThan: 'גדול מ',
    lessThanOrEqual: 'קטן או שווה ל',
    greaterThanOrEqual: 'גדול או שווה ל',
    inRange: 'בטווח',
    inRangeStart: 'מ',
    inRangeEnd: 'עד',
    before: 'לפני',
    after: 'אחרי',
    andCondition: 'וגם',
    orCondition: 'או',
    applyFilter: 'החל',
    resetFilter: 'אפס',
    clearFilter: 'נקה',
    cancelFilter: 'ביטול',
    true: 'כן',
    false: 'לא',
  },
  contextMenu: {
    copy: 'העתק',
    paste: 'הדבק',
    exportXlsx: 'יצוא לאקסל',
    openAssetForm: 'פתח הגדרת נייר',
    openFundForm: 'פתח הגדרת קרן',
    customize: 'התאמה אישית',
    quickFormat: 'עיצוב מהיר',
    quickFormatDecimal: 'מספר עשרוני',
    quickFormatInteger: 'מספר שלם',
    quickFormatIntegerSigned: 'מספר שלם, צבוע לפי סימן',
    quickFormatPercent: 'אחוזים',
    quickFormatPercentSigned: 'אחוזים, צבועים לפי סימן',
    quickFormatMonth: 'חודש',
    quickFormatNone: 'ללא פורמט',
    summaryRow: 'שורת סיכום',
    summaryNone: 'ללא',
    rowColor: 'צבע שורה',
    rowColorGreen: 'ירוק',
    rowColorYellow: 'צהוב',
    rowColorCustom: 'מותאם...',
    rowColorClear: 'נקה צבע',
    rowColorPickerLabel: 'בחירת צבע שורה',
  },
  bankAccounts: {
    pageTitle: 'חשבונות בנק',
    columnAcc: 'מספר חשבון',
    columnBank: 'בנק',
    columnBranch: 'סניף',
    columnFund: 'קרן',
    errorPrefix: 'שגיאה: {message}',
  },
  sidebar: {
    home: 'דף הבית',
    banks: 'בנקים',
    funds: 'קרנות',
    bankAccounts: 'חשבונות בנק',
    generalSettings: 'הגדרות כלליות',
    companySettings: 'הגדרות חברה',
    entities: 'ישויות',
    regulation: 'רגולציה',
    systemSettings: 'הגדרות מערכת',
    users: 'משתמשים',
    roles: 'תפקידים',
    searchPlaceholder: 'חיפוש מסך...',
    searchNoResults: 'לא נמצאו תוצאות',
    loadError: 'שגיאה בטעינת תפריט',
    recentTitle: 'ביקרת לאחרונה',
  },
  isaAssetTypes: {
    pageTitle: 'סוגי נכסים לרשות',
    columns: {
      isaCode: 'קוד רשות',
      name: 'שם',
    },
    validation: {
      isaCodeRequired: 'קוד רשות נדרש',
      isaCodePositive: 'קוד רשות חייב להיות מספר חיובי',
      nameRequired: 'שם נדרש',
      nameTooLong: 'שם ארוך מ-300 תווים',
    },
  },
  tradeMarkets: {
    pageTitle: 'שוקי מסחר',
    columns: {
      tradeMarketId: 'קוד',
      tradeMarketName: 'שם',
    },
  },
  tradePlaces: {
    pageTitle: 'מקומות מסחר',
    columns: {
      tradePlaceId: 'קוד',
      tradePlaceName: 'שם',
    },
  },
  trustees: {
    pageTitle: 'נאמנים',
    columns: {
      trusteeId: 'קוד',
      trusteeName: 'שם',
    },
  },
  baseAssetTypes: {
    pageTitle: 'סוגי נכס בסיס',
    columns: {
      baseAssetTypeId: 'קוד',
      baseAssetTypeName: 'שם',
    },
  },
  industryGroups: {
    pageTitle: 'קבוצות ענף',
    columns: {
      industryGroupId: 'קוד',
      industryGroupName: 'שם',
    },
  },
  assetTypeDefaultValues: {
    pageTitle: 'ערכי ברירת מחדל לסוג נכס',
    errorPrefix: 'שגיאה: {message}',
    columns: {
      recId: 'מזהה',
      assetTypeId: 'סוג נכס',
      targetColumn: 'שדה יעד',
      defaultValue: 'ערך ברירת מחדל',
      conditionColumn: 'שדה תנאי',
      conditionValue: 'ערך תנאי',
      isActive: 'פעיל',
    },
    tooltips: {
      targetColumn: 'שם העמודה ביעד (ASSETS); בשורות לא פעילות — שם השדה בלגאסי',
      conditionColumn: 'שורה מותנית (שדה+ערך תנאי) גוברת על שורה כללית לאותו שדה',
      isActive: 'לא פעיל = יעד לגאסי שטרם הוסב ל-LOP',
    },
  },
  industrySectors: {
    pageTitle: 'סקטורים של תעשיה',
    columns: {
      industrySectorId: 'קוד',
      industrySectorName: 'שם',
    },
  },
  inventoryRowTypes: {
    pageTitle: 'סוגי שורת מלאי',
    columns: {
      inventoryRowTypeId: 'קוד',
      inventoryRowTypeName: 'שם',
    },
  },
  swapKosherFunds: {
    pageTitle: 'SWAP קרנות כשרות',
    columns: {
      kosherFundId: 'קרן כשרה',
      equivalentFundId: 'קרן מקבילה',
      kosherAssetId: 'נייר כשר',
      equivalentAssetId: 'נייר מקביל',
    },
  },
  accountPurposes: {
    pageTitle: 'ייעוד חשבון',
    columns: {
      accountPurposeId: 'קוד',
      accountPurposeName: 'שם',
    },
  },
  accountLendingTypes: {
    pageTitle: 'סוגי חשבון להשאלות',
    columns: {
      accountLendingTypeId: 'קוד',
      accountLendingTypeName: 'שם',
    },
  },
  swapStatuses: {
    pageTitle: 'סטטוסי SWAP',
    columns: {
      swapStatusId: 'קוד',
      swapStatusName: 'שם',
    },
  },
  swapInterestTypes: {
    pageTitle: 'סוגי ריבית ל-SWAP',
    columns: {
      swapInterestTypeId: 'קוד',
      swapInterestTypeName: 'שם',
    },
  },
  optionsBlackScholes: {
    pageTitle: 'אופציות בלק-שולץ',
    columns: {
      assetId: 'קוד נייר',
      assetTypeId: 'סוג נייר',
      callOrPut: 'CALL/PUT',
      strike: 'מחיר מימוש',
      expDate: 'תפוגה',
      daysToExpire: 'ימים לפקיעה',
      baseAssetShovi: 'שווי נכס בסיס',
      ivBaseAsset: 'סטיית תקן גלומה',
      ribitBankIsrael: 'ריבית',
      bs: 'שווי (BS)',
      delta: 'דלתא',
      d1: 'd1',
      d2: 'd2',
      nd1: 'N(d1)',
      nd2: 'N(d2)',
      negNd1: 'N(-d1)',
      negNd2: 'N(-d2)',
      baseAssetShoviBase: 'שווי בסיס (פתיחה)',
      bsBase: 'שווי BS (פתיחה)',
      deltaBase: 'דלתא (פתיחה)',
      d1Base: 'd1 (פתיחה)',
      d2Base: 'd2 (פתיחה)',
      nd1Base: 'N(d1) פתיחה',
      nd2Base: 'N(d2) פתיחה',
      negNd1Base: 'N(-d1) פתיחה',
      negNd2Base: 'N(-d2) פתיחה',
    },
  },
  isaFundClassifications: {
    pageTitle: 'סיווגי קרנות לפי רשות',
    columns: {
      isaFundClassificationId: 'קוד',
      isaFundClassificationName: 'שם',
    },
  },
  operators: {
    pageTitle: 'מתפעלים',
    columns: {
      operatorId: 'קוד',
      operatorName: 'שם',
    },
  },
  prospectusExposureTypes: {
    pageTitle: 'סוגי חשיפה לתשקיפים',
    columns: {
      prospectusExposureTypeId: 'קוד',
      prospectusExposureTypeName: 'שם',
    },
  },
  prospectusExtraDetails: {
    pageTitle: 'פרטים נוספים לתשקיפים',
    columns: {
      extraDetailId: 'קוד',
      extraDetailName: 'תיאור',
    },
  },
  companies: {
    pageTitle: 'חברות',
    columns: {
      companyId: 'קוד',
      companyHebName: 'שם בעברית',
      companyEngName: 'שם באנגלית',
      crn: 'ח"פ',
    },
  },
  fundClassifications: {
    pageTitle: 'סיווג קרנות',
    columns: {
      fundClassificationId: 'קוד',
      fundClassificationName: 'שם',
    },
  },
  ratingLevels: {
    pageTitle: 'רמות דירוג',
    columns: {
      recId: 'מזהה',
      rating: 'דירוג',
      levelCode3: 'קוד רמה',
      ratingGroupId: 'קבוצת דירוג',
    },
  },
  ratingScale: {
    pageTitle: 'סולם דירוגים',
    columns: {
      ratingOrder: 'דירוג',
      maalot: 'מעלות',
      midroog: 'מידרוג',
      moodys: "Moody's",
      sp: 'S&P',
      fitch: 'Fitch',
      fitchShort: 'Fitch ק"ט',
      moodysShort: 'Moody\'s ק"ט',
      spShort: 'S&P ק"ט',
    },
  },
  categoryMap: {
    pageTitle: 'מיפוי קטגוריות',
    columns: {
      assetTypeId: 'סוג נכס',
      balanceTypeId: 'קוד יתרה',
      categoryId: 'קטגוריה',
    },
  },
  creditSourceGroups: {
    pageTitle: 'קבוצות מקור אשראי',
    columns: {
      creditSourceGroupId: 'קוד',
      creditSourceGroupName: 'שם',
      creditSourceTypeId: 'סוג מקור',
    },
  },
  creditSourceGroupMap: {
    pageTitle: 'מיפוי קבוצות מקור אשראי',
    columns: {
      assetTypeId: 'סוג נכס',
      balanceTypeId: 'קוד יתרה',
      creditSourceGroupId: 'קבוצת מקור אשראי',
    },
  },
  creditRiskTypes: {
    pageTitle: 'סיכון אשראי - צד נגדי',
    columns: {
      creditRiskTypeId: 'קוד',
      creditRiskTypeName: 'שם',
      creditRiskTypeId4Rashut: 'קוד רשות',
    },
  },
  isaCreditRiskTypes: {
    pageTitle: 'סוגי סיכון אשראי',
    columns: {
      creditRiskTypeId: 'קוד',
      creditRiskTypeName: 'שם',
    },
  },
  tradePlacesBloomberg: {
    pageTitle: 'מקומות מסחר בלומברג',
    columns: {
      tradePlaceIdBloomberg: 'קוד בלומברג',
      tradePlaceId: 'מקום מסחר (רשות)',
      isLeadingExchange: 'בורסה מקדימה',
      countryId: 'קוד מדינה',
    },
  },
  continents: {
    pageTitle: 'יבשות',
    columns: {
      continentId: 'קוד',
      continentName: 'שם',
      disclosureCodeEnding: 'סיומת קוד גילוי נאות',
    },
  },
  countries: {
    pageTitle: 'ארצות',
    columns: {
      countryId: 'קוד',
      countryCode: 'קוד מדינה',
      nameEn: 'שם באנגלית',
      nameHe: 'שם בעברית',
      continentId: 'יבשת',
      countryId4Rashut: 'קוד רשות',
      bloombergName: 'שם בלומברג',
      tax: 'מס',
    },
  },
  ratingCompanies: {
    pageTitle: 'חברות מדרגות',
    columns: {
      ratingCompanyId: 'קוד',
      ratingCompanyName: 'שם',
    },
  },
  isaSecurityIdTypes: {
    pageTitle: 'סוגי מזהה נייר ערך',
    columns: {
      securityIdTypeId: 'קוד רשות',
      securityIdTypeName: 'שם',
    },
    validation: {
      securityIdTypeIdRequired: 'קוד רשות נדרש',
      securityIdTypeIdPositive: 'קוד רשות חייב להיות מספר חיובי',
      securityIdTypeNameRequired: 'שם נדרש',
      securityIdTypeNameTooLong: 'שם ארוך מ-300 תווים',
    },
  },
  assetTypes: {
    pageTitle: 'סוגי ניירות',
    columns: {
      assetTypeId: 'קוד',
      assetTypeName: 'שם',
      multiplier: 'כופל',
    },
    validation: {
      assetTypeIdRequired: 'קוד נדרש',
      assetTypeIdPositive: 'קוד חייב להיות מספר חיובי',
      assetTypeNameRequired: 'שם נדרש',
      assetTypeNameTooLong: 'שם ארוך מ-300 תווים',
    },
  },
  sources: {
    pageTitle: 'מקורות',
    columns: {
      sourceId: 'קוד',
      sourceName: 'שם',
    },
  },
  lendingFeeCalcTypes: {
    pageTitle: 'סוגי חישוב עמלת השאלה',
    columns: {
      lendingFeeCalcTypeId: 'קוד',
      lendingFeeCalcTypeName: 'שם',
      comment: 'הערה',
    },
  },
  issuers: {
    pageTitle: 'חברות מנפיקות',
    columns: {
      issuerId: 'קוד',
      issuerName: 'שם חברה',
      crn: 'ח.פ.',
    },
  },
  benchmarkRates: {
    pageTitle: 'ריביות עוגן',
    columns: {
      benchmarkRateId: 'קוד',
      benchmarkRateName: 'שם',
    },
  },
  benchmarkRatePeriods: {
    pageTitle: 'תקופות ריבית עוגן',
    columns: {
      benchmarkRatePeriodId: 'קוד',
      benchmarkRatePeriodName: 'שם',
    },
  },
  bfixSpecialDays: {
    pageTitle: 'שערים מיוחדים BFIX',
    errorPrefix: 'שגיאה: {message}',
    columns: {
      dDate: 'תאריך',
      bfixRateTypeId: 'סוג שער',
      aComment: 'הערה',
    },
  },
  bfixRateTypes: {
    pageTitle: 'סוגי שער BFIX',
    columns: {
      bfixRateTypeId: 'קוד',
      bfixRateTypeName: 'שם',
    },
  },
  calcTypes: {
    pageTitle: 'סוגי חישוב',
    columns: {
      calcTypeId: 'קוד',
      calcTypeCode: 'מזהה אנגלית',
      calcTypeName: 'שם',
    },
  },
  calcMethods: {
    pageTitle: 'שיטות חישוב',
    columns: {
      calcMethodId: 'קוד',
      calcTypeId: 'סוג חישוב',
      calcMethodCode: 'מזהה אנגלית',
      calcMethodName: 'שם',
      calcMethodDetails: 'נוסחה',
    },
  },
  calcMethodMap: {
    pageTitle: 'מיפוי שיטות חישוב',
    columns: {
      balanceTypeId: 'קוד יתרה',
      assetTypeId: 'סוג נכס',
      calcMethodId: 'שיטת שיערוך',
      exposureCalcMethodId: 'שיטת חשיפה',
    },
  },
  balanceTypes: {
    pageTitle: 'קודי יתרה',
    columns: {
      balanceTypeId: 'קוד',
      balanceTypeName: 'שם',
    },
  },
  priceTypes: {
    pageTitle: 'סוגי מחירים',
    columns: {
      priceTypeId: 'קוד',
      priceTypeName: 'שם',
      isSpecialRate4Valuation: 'שער מיוחד לשיערוך',
    },
  },
  alerts: {
    pageTitle: 'שים לב',
    empty: 'אין התראות פעילות',
    retry: 'נסה שוב',
    runRefresh: 'הרץ בדיקה',
    refreshing: 'מריץ...',
    topbarAriaLabel: 'שים לב — התראות',
    columns: {
      alertId: 'מזהה',
      fundId: 'מספר קרן',
      fundName: 'שם קרן',
      assetId: 'מספר נייר',
      description: 'תיאור',
    },
  },
  alertTypes: {
    pageTitle: 'סוגי התראות',
    columns: {
      alertTypeId: 'קוד',
      alertTypeCode: 'מזהה אנגלית',
      alertTypeName: 'שם',
      scope: 'תחום',
      severity: 'חומרה',
    },
    severity: {
      critical: 'קריטי',
      severe: 'חמור',
      light: 'קל',
    },
  },
  rates: {
    pageTitle: 'שערי ניירות',
    columns: {
      assetId: 'מספר נייר',
      baseRate: 'שער בסיס',
      currRate: 'שער נוכחי',
      nav: 'NAV',
      value1Point: 'ערך נקודה',
      sourceId: 'מקור',
      navDate: 'תאריך NAV',
      ivBaseAsset: 'סטיית תקן גלומה',
      ribitOptions: 'ריבית אופציות',
      kofelBaseRate: 'כופל שער בסיס',
    },
  },
  ratesHistory: {
    pageTitle: 'שערים היסטוריים',
    columns: {
      dDate: 'תאריך',
      assetId: 'מספר נייר',
      baseRate: 'שער בסיס',
      currRate: 'שער נוכחי',
      nav: 'NAV',
      value1Point: 'ערך נקודה',
      sourceId: 'מקור',
      navDate: 'תאריך NAV',
      ivBaseAsset: 'סטיית תקן גלומה',
      ribitOptions: 'ריבית אופציות',
      kofelBaseRate: 'כופל שער בסיס',
    },
  },
  idxRates: {
    pageTitle: 'שערי מדדים',
    columns: {
      idxId: 'מספר מדד',
      baseRate: 'שער בסיס',
      openRate: 'שער פתיחה',
      currRate: 'שער נוכחי',
    },
  },
  idxRatesHistory: {
    pageTitle: 'שערי מדדים היסטוריים',
    columns: {
      dDate: 'תאריך',
      idxId: 'מספר מדד',
      baseRate: 'שער בסיס',
      openRate: 'שער פתיחה',
      currRate: 'שער נוכחי',
    },
  },
  idxCompositions: {
    pageTitle: 'הרכב מדדים',
    columns: {
      idxId: 'קוד מדד',
      assetId: 'מספר נייר',
      assetPercent: 'אחוז נייר',
      factor: 'פקטור',
    },
    filter: {
      idx: 'מדד',
      all: '(הכל)',
      search: 'חיפוש מדד',
    },
  },
  idxCompositionsHistory: {
    pageTitle: 'הרכב מדדים היסטורי',
    columns: {
      dDate: 'תאריך',
      idxId: 'קוד מדד',
      assetId: 'מספר נייר',
      assetPercent: 'אחוז נייר',
      factor: 'פקטור',
    },
  },
  taseIdxCompositions: {
    pageTitle: 'הרכב מדדי הבורסה',
    columns: {
      dDate: 'תאריך',
      taseIdxId: 'קוד מדד בבורסה',
      assetId: 'מספר נייר',
      assetPercent: 'אחוז נייר',
      factor: 'פקטור',
    },
    filter: {
      date: 'תאריך',
      idx: 'מדד',
      all: '(הכל)',
    },
  },
  publishedFundRates: {
    pageTitle: 'שערי קרנות מפורסמים',
    columns: {
      recId: 'מזהה',
      assetId: 'מספר נייר',
      assetName: 'שם קרן',
      rateDate: 'תאריך שער',
      capturedAt: 'זמן קליטה',
      nav: 'שער יחידה',
      bidRate: 'שער פדיון',
      askRate: 'שער יצירה',
      manualRate: 'שער ידני',
    },
  },
  disclosureLevel1: {
    pageTitle: 'גילוי נאות - רובד 1',
    columns: {
      codeId: 'קוד',
      codeName: 'שם',
    },
  },
  disclosureLevel2: {
    pageTitle: 'גילוי נאות - רובד 2',
    columns: {
      parentCodeId: 'קוד אב',
      codeId: 'קוד',
      codeName: 'שם',
    },
  },
  disclosureLevel3: {
    pageTitle: 'גילוי נאות - רובד 3',
    columns: {
      parentCodeId: 'קוד אב',
      codeId: 'קוד',
      codeName: 'שם',
    },
  },
  disclosureLevel4: {
    pageTitle: 'גילוי נאות - רובד 4',
    columns: {
      parentCodeId: 'קוד אב',
      codeId: 'קוד',
      codeName: 'שם',
    },
  },
  sysadminTools: {
    pageTitle: 'מסך עזר',
    subtitle: 'כלים תפעוליים זמינים למנהל מערכת בלבד.',
    runAlerts: {
      title: 'רענון התראות (שים לב)',
      description:
        'מריץ את הבדיקות הלוגיות על נתוני הטננט הפעיל ומרענן את רשימת ההתראות. הרשימה מתאפסת ונטענת מחדש — תקלה שתוקנה לא תופיע בריצה הבאה.',
      button: 'הרץ עכשיו',
      running: 'מריץ...',
      success: 'הסתיים — {count} התראות פעילות',
    },
    runTaseRates: {
      title: 'קליטת שערי בורסה (סוף יום)',
      description:
        'מריץ קליטת שערי ניירות מהבורסה עבור טווח התאריכים שנבחר. הקליטה אידמפוטנטית — ניתן להריץ שוב או להרחיב את הטווח כדי להשלים פער, ללא כפילויות.',
      fromLabel: 'מתאריך',
      toLabel: 'עד תאריך',
      button: 'הרץ קליטה',
      running: 'מריץ...',
      success: 'נקלטו {count} שערים',
    },
  },
  holdings: {
    pageTitle: 'אחזקות',
    fundLabel: 'קרן:',
    allFunds: 'כל הקרנות',
    selectFund: 'בחר קרן',
    clearFund: 'נקה בחירה',
    fetch: 'הבא נתונים',
    staleIndicator: 'הנתונים אינם תואמים לבחירה — לחץ "הבא נתונים" כדי לרענן',
    errorPrefix: 'שגיאה בטעינת אחזקות: {message}',
    // Hebrew labels for the view's rateSource text (unknown values are shown raw).
    rateSources: {
      current: 'שער נוכחי',
      closing: 'שער סגירה',
      specialRate: 'שער מיוחד',
      navCurrent: 'NAV נוכחי',
      navClosing: 'NAV סגירה',
      notInCatalog: 'נייר לא קיים בקטלוג',
      tbd: 'חסר נתון (בפיתוח)',
    },
    columns: {
      inventoryId: 'מזהה',
      acc: 'חשבון',
      assetId: 'נייר',
      assetName: 'שם נייר',
      symbol: 'סימול',
      assetTypeId: 'סוג נייר',
      balanceTypeId: 'קוד יתרה',
      qty: 'כמות',
      qty4Receive: 'כמות לקבל',
      rate4Valuation: 'שער שיערוך',
      crcyRate4Valuation: 'שע"מ שיערוך',
      inventorySourceId: 'מקור',
      expirationDate: 'תאריך פקיעה',
      remark: 'הערה',
      executionDate: 'תאריך ביצוע',
      indexRate4Valuation: 'מדד שיערוך',
      indexRatio4Valuation: 'יחס מדד',
      rateSource: 'מקור שער',
      rateDate: 'תאריך שער',
      manualRateComment: 'הערת שער ידני',
      valuationKind: 'סוג שיערוך',
      forwardExecutionRate: 'שער ביצוע פורוורד',
      priceTypeId: 'סוג מחיר',
      fundId: 'קוד קרן',
      fundName: 'שם קרן',
      fundOfficialName: 'שם קרן רשמי',
      fundAssetId: 'מספר בורסה',
      fundTypeId: 'סוג קרן',
      bankId: 'בנק',
      branch: 'סניף',
      crcyId: 'מטבע',
      expDate: 'פקיעת נייר',
      idxId: 'מדד',
      createdAt: 'נוצר',
      updatedAt: 'עודכן',
      calcMethodCode: 'שיטה',
      multiplier: 'כופל',
      valuation: 'שיערוך',
    },
    contextMenu: {
      calcDetails: 'פירוט חישובים',
      lendingFeeDetails: 'פירוט דמי השאלה',
    },
    calcDetails: {
      title: 'פירוט חישוב שיערוך',
      methodCode: 'קוד שיטה',
      methodName: 'שם',
      hebrewDescription: 'תיאור עברי',
      sqlFormula: 'נוסחה',
      substituted: 'הצבת ערכים',
      result: 'תוצאה',
      formulaNotDefined: 'נוסחה לא הוגדרה עדיין',
      methodNotFound: 'שיטה לא נמצאה בקטלוג',
      noRow: '—',
      close: 'סגור',
    },
  },
  lendings: {
    pageTitle: 'השאלות',
    bankLabel: 'בנק',
    allBanks: 'כל הבנקים',
    bankOption: '{bankName} ({count})',
    noBanks: 'אין השאלות פתוחות',
    accLabel: 'חשבון',
    allAccounts: '(כל החשבונות)',
    columns: {
      bankName: 'בנק',
      acc: 'חשבון',
      fundName: 'קרן',
      assetId: 'מספר נייר',
      assetName: 'שם נייר',
      qty: 'כמות מושאלת',
      startDate: 'תחילת השאלה',
      endDate: 'סיום השאלה',
      startRate: 'שער בתחילת ההשאלה',
      feePercent: 'אחוז עמלה שנתי',
      accruedFee: 'עמלה שטרם שולמה',
      accrualDays: 'ימי הזחלה',
      feeBuiltAt: 'עמלה חושבה ב-',
      calcTypeName: 'שיטת חישוב עמלה',
      calcTypeSource: 'מקור השיטה',
      side: 'צד',
      bankRef: 'אסמכתת בנק',
      asOfDate: 'תאריך שיערוך',
    },
    contextMenu: {
      explainFee: 'הסבר עמלה',
    },
    explain: {
      title: 'הסבר עמלה',
      close: 'סגור',
      loading: 'טוען...',
      loadError: 'טעינת הסבר העמלה נכשלה',
      method: {
        heading: 'שיטת החישוב',
        name: 'שיטה',
        source: 'מקור השיטה',
        sourceBank: 'נקבעה לפי הבנק',
        sourceLending: 'נקבעה בהשאלה עצמה (דורסת את שיטת הבנק)',
        comment: 'הערה',
        rateBasis: 'שער',
        dayCountBasis: 'ספירת ימים',
        yearBasis: 'בסיס שנה',
        chargeTiming: 'מועד תשלום',
        calcKind: 'סוג חישוב',
        unknownValue: 'ערך לא מוכר: {code}',
      },
      values: {
        rateBasis: {
          openDayClose: 'שער הסגירה ביום פתיחת ההשאלה',
          openDayBase: 'שער הבסיס האחרון הידוע ביום הפתיחה',
          dailyLastKnown: 'השער האחרון הידוע בכל יום',
          endOfDealClose: 'שער הסגירה בתום העסקה (עד סיום: הסגירה האחרונה הידועה)',
          dailyBase: 'שער הבסיס של כל יום',
        },
        dayCountBasis: {
          inclusive: 'כולל יום ההחזרה',
          exclusive: 'לא כולל יום ההחזרה (סיום פחות תחילה)',
        },
        yearBasis: {
          fixed365: 'חלוקה קבועה ב-365',
          actualYear: 'ימי השנה בפועל; תקופה החוצה שנה מפוצלת ומחושבת בנפרד',
        },
        chargeTiming: {
          prepaid: 'תשלום מראש - הזחלה שלילית: מה שטרם נצבר',
          monthEnd: 'תשלום בסוף כל חודש - הזחלה חיובית: מתחילת החודש עד היום',
          atEnd: 'תשלום בסוף - הזחלה חיובית: מה שנצבר עד היום',
          quarterly: 'תשלום רבעוני (טרם ממומש)',
        },
        calcKind: {
          linear: 'ליניארי: כמות x שער x עמלה שנתית x ימים / ימי שנה',
          compound: 'ריבית דריבית (רד"ר)',
          fixed: 'סכום קבוע (טרם ממומש)',
        },
      },
      data: {
        heading: 'נתוני ההשאלה',
        qty: 'כמות מושאלת',
        startRate: 'שער בתחילת ההשאלה',
        feePercent: 'אחוז עמלה שנתי',
        startDate: 'תחילת השאלה',
        endDate: 'סיום השאלה',
        onCall: 'ללא תאריך סיום (ON-CALL)',
        asOfDate: 'תאריך שיערוך',
      },
      breakdown: {
        heading: 'פירוט החישוב',
        noRows: 'אין שורות פירוט - לא ניתן להסביר את העמלה',
        kind: 'סוג',
        fromDate: 'מתאריך',
        toDate: 'עד תאריך',
        days: 'ימים',
        daysInYear: 'ימי שנה',
        qty: 'כמות',
        rateUsed: 'שער',
        rateSourceDate: 'תאריך השער',
        rateSource: 'מקור השער',
        feePercent: 'עמלה שנתית',
        notional: 'שווי',
        sign: 'סימן',
        componentFee: 'עמלה (עם סימן)',
        total: 'סכום שיועבר למלאי',
        totalSum: 'סכום השורות',
        signNegative: 'שלילי = שולם מראש וטרם נצבר',
        signPositive: 'חיובי = נצבר ועדיין לא שולם',
        unknown: 'לא ניתן לחשב - שיטה לא ממומשת / שער חסר',
        stale: 'לא מעודכן - נבנה ב-{builtAt}',
      },
    },
  },
  inventory: {
    pageTitle: 'מלאי',
    accountLabel: 'חשבון',
    allAccounts: 'כל החשבונות',
    searchAccount: 'חיפוש חשבון',
    accountName: 'שם חשבון',
    accountFundId: 'מזהה קרן',
    accountBankId: 'בנק',
    columns: {
      acc: 'חשבון',
      assetId: 'מספר נייר',
      assetName: 'שם נייר',
      balanceTypeId: 'סוג יתרה',
      qty: 'כמות',
      qty4Receive: 'כמות לקבל',
      inventorySourceId: 'מקור',
      sourceName: 'שם מקור',
      expirationDate: 'תפוגה',
      remark: 'הערה',
      executionDate: 'תאריך ביצוע',
      forwardExecutionRate: 'שער ביצוע פורוורד',
      priceTypeId: 'סוג מחיר',
      inventoryRowTypeId: 'סוג שורה',
      inventoryRowTypeName: 'שם סוג שורה',
      createdAt: 'נוצר',
      updatedAt: 'עודכן',
    },
  },
  fundDataHistory: {
    pageTitle: 'שערי קרנות היסטוריים',
    fundLabel: 'קרן:',
    selectFundPlaceholder: 'בחר קרן',
    noFundSelected: 'בחר קרן כדי להציג נתונים',
    errorPrefix: 'שגיאה בטעינת שערי קרן היסטוריים: {message}',
    columns: {
      dDate: 'תאריך',
      isFilled: 'שורת מילוי',
      finalRate: 'שער סופי',
      netRate: 'שער נטו',
      grossRate: 'שער ברוטו',
      unitPrice: 'מחיר יחידה',
      redemptionPrice: 'מחיר פדיון',
      grossAssetsValue: 'שווי נכסים',
      netAssetsValue: 'שווי נכסים נטו',
      publicUnits: 'כמות בידי הציבור',
      dailyTrackingError: 'טעות עקיבה',
      totalDmf: 'דמ"נ משתנים מצטבר',
      securityStrip: 'רצועה נותרת',
      navByCrcy: 'NAV במטבע',
      originDate: 'תאריך מקור',
      updatedAt: 'עודכן',
    },
  },
  rolePermissions: {
    pageTitle: 'הרשאות',
    columns: {
      roleName: 'תפקיד',
      resourceDescription: 'מסך',
      permissionLevel: 'רמת הרשאה',
    },
    levels: {
      none: 'ללא',
      view: 'צפייה',
      edit: 'עריכה',
    },
  },
  funds: {
    title: 'קרנות נאמנות',
    formTitle: 'הגדרת קרן',
    searchPlaceholder: 'חיפוש קרן',
    columnFundId: 'מזהה',
    columnFundName: 'שם הקרן',
    columnFundOfficialName: 'שם רשמי',
    columnFundType: 'סוג קרן',
    columnFundAssetId: 'מס\' נייר ערך',
    chipAssetNo: 'מס\' נייר',
    chipIsraeli: 'ישראלית',
    chipForeign: 'זרה',
    columnTradingStartDate: 'תאריך תחילת מסחר',
    errorPrefix: 'שגיאה: {message}',
    noneOption: '— ללא —',
    sections: {
      identity: 'זיהוי',
      classification: 'סיווג ושיוך',
      currency: 'מטבע',
      fees: 'דמי ניהול ונאמנות',
      flags: 'מאפיינים',
      datesValuation: 'תאריכים ושיערוך',
    },
    cols: {
      issuerId: 'מנפיק',
      issuedQuantity: 'כמות מונפקת',
      conversionPercent: 'אחוז המרה',
      managementFeePercent: 'דמי ניהול %',
      managementFeeStartDate: 'תחילת דמי ניהול',
      includedInIsaReport: 'נכלל בדוח רשות',
      isActive: 'פעיל',
      name4Isa: 'שם לרשות',
      trusteeId: 'נאמן',
      leverage: 'מינוף',
      fundClassificationId: 'סיווג קרן',
      crcyId: 'מטבע',
      createdDate: 'תאריך יצירה',
      allow2HoldInternal: 'מותר להחזיק פנימי',
      allow2BeInternal: 'מותר להיות פנימי',
      isForeign: 'זר',
      nickName: 'כינוי',
      nameEn: 'שם באנגלית',
      companyId: 'חברה',
      magnaNumber: 'מספר מגנא',
      lastTrusteePaymentDate: 'תשלום נאמן אחרון',
      trusteeFeePercent: 'דמי נאמנות %',
      dynamicManagementFeePercent: 'דמי ניהול דינמיים %',
      isComposite: 'מורכבת',
      indexRateDmfFirstDay: 'שער מדד יום ראשון DMF',
      fundRateDmfFirstDay: 'שער קרן יום ראשון DMF',
      balanceMfFirstDay: 'יתרת ד.ניהול יום ראשון',
      balanceTrusteeFeeFirstDay: 'יתרת ד.נאמנות יום ראשון',
      balanceDmfFirstDay: 'יתרת DMF יום ראשון',
      lastValuationAt: 'שיערוך אחרון',
      lastManagementFeePaymentDate: 'תשלום ד.ניהול אחרון',
      dmfStartDate: 'תחילת DMF',
      crcyRateDmfFirstDay: 'שער מטבע יום ראשון DMF',
      trusteeFeeStartDate: 'תחילת דמי נאמנות',
      valuationOrderGroup: 'קבוצת סדר שיערוך',
      isPreMarketExchange: 'בורסה מקדימה',
      interestCrcyTicker: 'טיקר מטבע ריבית',
      firstDayIndexCrcyRate: 'שער מטבע מדד יום ראשון',
      isLatePreMarketExchange: 'בורסה מקדימה מאוחרת',
      sample1730AtDmfStartDate: 'דגימה 17:30 בתחילת DMF',
      lastTradeDate: 'מסחר אחרון',
      eodCrcyId: 'מטבע EOD',
      isaFundClassificationId: 'סיווג קרן לפי רשות',
      isCollateralInCreditLeverage: 'בטוחות במנוף אשראי',
      determiningDate: 'יום קובע',
      prospectusExposureTypeId: 'סוג חשיפה לתשקיף',
      operatorId: 'מתפעל',
      creationSpread: 'מרווח יצירה',
      redemptionSpread: 'מרווח פדיון',
      nominalCrcyId: 'מטבע נקוב',
      dmfPsagotPlugNumber: 'מספר פלאג DMF',
      redemptionLimitsStartDate: 'תחילת מגבלות פדיון',
      firstTradeDateNav: 'שער יום מסחר ראשון',
    },
    tooltips: {
      firstTradeDateNav: 'שער הקרן ביום המסחר הראשון — מוזן ידנית כי כמות היחידות בבוקר יום המסחר הראשון היא 0',
    },
  },
  fundFeeChange: {
    title: 'שינוי אחוז דמי {feeType}',
    trustee: 'נאמן',
    management: 'ניהול',
    message: 'קיימת כבר שורה ביומן דמי ה{feeType} בטווח של שבוע (תאריך {date}, ערך {value}). לעדכן את השורה הקיימת או להוסיף שורה חדשה?',
    updateExisting: 'עדכן את הקיימת',
    addNew: 'הוסף חדשה',
    cancel: 'ביטול',
    cancelledStatus: 'השמירה בוטלה',
  },
  fundAccounts: {
    panelTitle: 'חשבונות בנק של הקרן',
    managedElsewhereNote: 'הוספה והסרה של חשבונות מתבצעת במסך "חשבונות בנק"',
    manageAccountsCta: 'נהל חשבונות',
    manageAccountsAriaLabel: 'נהל חשבונות הקרן {fundName} במסך "חשבונות בנק"',
    emptyHeadline: 'אין חשבונות בנק מקושרים לקרן זו',
    emptyHelper: 'לחץ "נהל חשבונות" כדי להוסיף',
    columnBank: 'בנק',
    columnBranch: 'סניף',
    columnAcc: 'מס\' חשבון',
    loadError: 'שגיאה בטעינת חשבונות הקרן: {message}',
  },
  fundIndices: {
    panelTitle: 'מדדים שהקרן עוקבת אחריהם',
    addIndex: 'הוסף מדד',
    columnIndex: 'מדד',
    columnPercent: 'אחוז',
    columnActions: 'פעולות',
    pickIndexPlaceholder: 'חפש מדד…',
    searchIndex: 'חיפוש מדד מרשימה',
    removeRow: 'הסר מדד',
    total: 'סה"כ',
    save: 'שמור מדדים',
    saving: 'שומר…',
    saved: 'המדדים נשמרו',
    loadError: 'שגיאה בטעינת מדדי הקרן: {message}',
    emptyHeadline: 'קרן זו אינה עוקבת אחר מדדים',
    emptyHelper: 'לחץ "הוסף מדד" כדי לשייך מדד',
    errPickIndex: 'יש לבחור מדד בכל שורה',
    errPositive: 'האחוז בכל שורה חייב להיות גדול מ-0',
    errDuplicate: 'אותו מדד מופיע יותר מפעם אחת',
    errShort: 'הסכום חסר ב-{diff}% (חייב להסתכם ל-100%)',
    errOver: 'הסכום עודף ב-{diff}% (חייב להסתכם ל-100%)',
  },
  categories: {
    title: 'קטגוריות',
    columnCategoryId: 'מזהה',
    columnCategoryName: 'שם קטגוריה',
    columnIsDetailed4IsaReport: 'מפורט בדוח רשות',
    columnIsaCode: 'סוג נכס לרשות',
    columns: {
      groupingLevelId: 'רמת קיבוץ בדוח רשות',
    },
    noneOption: '— ללא —',
    errorPrefix: 'שגיאה: {message}',
  },
  currencyNonSettlementDates: {
    pageTitle: 'ימי אי-סליקה',
    columns: {
      recId: 'מזהה',
      crcyId: 'מטבע',
      nonSettlementDate: 'תאריך',
    },
    errorPrefix: 'שגיאה: {message}',
  },
  specialRates: {
    generalPageTitle: 'שערים מיוחדים כללי',
    tenantPageTitle: 'שערים מיוחדים – מנהל קרן',
    effectivePageTitle: 'שערים מיוחדים אפקטיביים',
    errorPrefix: 'שגיאה: {message}',
    columns: {
      recId: 'מזהה',
      assetId: 'נייר',
      dDate: 'תאריך',
      rate: 'שער',
      priceTypeId: 'סוג מחיר',
      manualRateComment: 'הערה/סיבה',
      isUpdateOnlineToo: 'עדכון אונליין',
      rateSource: 'מקור',
    },
    source: {
      central: 'כללי',
      tenant: 'טננט',
    },
    range: {
      addRange: 'הוספת טווח',
      fromDate: 'מתאריך',
      tillDate: 'עד תאריך',
      rangeButton: 'הוסף טווח',
      validation: 'יש למלא נייר, מתאריך, עד תאריך, שער וסוג מחיר',
      pickAsset: 'בחר נייר מטבלת הניירות',
    },
  },
  agenda: {
    pageTitle: 'סדר יום',
    errorPrefix: 'שגיאה: {message}',
    progress: 'בוצעו {done} מתוך {total}',
    ready: 'מוכן',
    blockedN: 'חסר {count}',
    searchPlaceholder: 'חיפוש פעולה...',
    filterAll: 'הכל',
    filterUndone: 'לא בוצע',
    filterBlocking: 'חוסם שיערוך',
    filterBeforeOpen: 'לפני פתיחת יום',
    noMatch: 'אין פעולות תואמות לסינון',
    noActionsToday: 'אין פעולות מתוכננות להיום',
    markDone: 'סמן כבוצע',
    markUndone: 'בטל סימון',
    central: 'מרכזי',
    beforeOpenDay: 'לפני פתיחת יום',
    reqIsraeli: 'חובה לשיערוך ישראלים',
    reqForeign: 'חובה לשיערוך זרים',
    commentToggle: 'הערה',
    commentRequired: 'נדרשת הערה כדי לסמן כבוצע',
    commentPlaceholder: 'הערה (חובה לפעולה זו)',
    srHasN: 'שים לב: יש {count} שערים מיוחדים במלאי (קרנות מחקות/סל פעילות)',
    srNone: 'אין שערים מיוחדים במלאי',
    srHandledQuestion: 'האם כל נושא השערים המיוחדים טופל?',
    srApprove: 'אישור — טופל',
    srConfirmedN: 'אושר — {count} שערים מיוחדים',
    srConfirmedNone: 'אושר — אין שערים מיוחדים',
  },
  agendaActions: {
    pageTitle: 'אג״נדה - הגדרת פעולות',
    errorPrefix: 'שגיאה: {message}',
    columns: {
      recId: 'מזהה',
      scope: 'רמה',
      actionCode: 'קוד פעולה',
      categoryId: 'קטגוריה',
      actionName: 'שם הפעולה',
      actionDescription: 'תיאור',
      dueSunday: "א'",
      dueMonday: "ב'",
      dueTuesday: "ג'",
      dueWednesday: "ד'",
      dueThursday: "ה'",
      dueFriday: "ו'",
      beforeOpenDay: 'לפני פתיחת יום',
      required4ValuationIsraeli: 'חובה לשיערוך ישראלים',
      required4ValuationForeign: 'חובה לשיערוך זרים',
      logicalOrder: 'סדר',
      ask4Comment: 'דורש הערה',
      rowColor: 'צבע',
      isActive: 'פעיל',
    },
  },
  agendaCategories: {
    pageTitle: 'אג״נדה - קטגוריות',
    errorPrefix: 'שגיאה: {message}',
    columns: {
      categoryId: 'מזהה',
      categoryName: 'שם קטגוריה',
      isActive: 'פעיל',
    },
  },
  valuationTypes: {
    pageTitle: 'סוגי שיערוך',
    errorPrefix: 'שגיאה: {message}',
    columns: {
      valuationTypeId: 'מזהה',
      valuationTypeCode: 'קוד',
      valuationTypeName: 'שם',
      isActive: 'פעיל',
    },
  },
  nonQuantoDays: {
    pageTitle: 'ימים ללא קוואנטו',
    errorPrefix: 'שגיאה: {message}',
    columns: {
      recId: 'מזהה',
      dDate: 'תאריך',
      comment: 'הערה',
    },
  },
  forwardInterestSettings: {
    pageTitle: 'הגדרת נקודות בלומברג למשיכה',
    errorPrefix: 'שגיאה: {message}',
    columns: {
      assetId: 'קוד נייר',
      assetName: 'שם הנכס',
      ticker: 'טיקר',
      days: 'מספר ימים',
      period: 'תקופה',
      ledCrcyId: 'מטבע מובל',
      leaderCrcyId: 'מטבע מוביל',
    },
    wizard: {
      addButton: 'הוספת נקודה',
      title: 'הוספת נקודת בלומברג למשיכה',
      submit: 'שמור',
      submitting: 'שומר…',
      validation: 'יש למלא שם נכס, טיקר, מספר ימים ושני המטבעות',
    },
  },
  nonDmf4Fund: {
    pageTitle: 'ימים ללא דמי ניהול משתנים',
    errorPrefix: 'שגיאה: {message}',
    columns: {
      recId: 'מזהה',
      dDate: 'תאריך',
      fundId: 'קרן',
      reason: 'סיבה',
    },
  },
  nonTradingDays4Fund: {
    pageTitle: 'ימים ללא מסחר לקרן',
    errorPrefix: 'שגיאה: {message}',
    columns: {
      recId: 'מזהה',
      dDate: 'תאריך',
      fundId: 'קרן',
      comment: 'הערה',
      userId: 'משתמש',
    },
  },
  capitalConsolidations: {
    pageTitle: 'איחוד הון',
    errorPrefix: 'שגיאה: {message}',
    columns: {
      fundId: 'קרן',
      fundName: 'שם הקרן',
      dDate: 'תאריך',
      consolidationRatio: 'יחס איחוד',
      redemptionUnits: 'יחידות לפדיון',
    },
  },
  relatedIssuers: {
    pageTitle: 'מנפיקים קשורים',
    errorPrefix: 'שגיאה: {message}',
    columns: {
      issuerId: 'קוד מנפיק',
      trusteeId: 'נאמן',
      fromDate: 'מתאריך',
      toDate: 'עד תאריך',
    },
  },
  creationRedemptions: {
    pageTitle: 'יצירות ופדיונות',
    errorPrefix: 'שגיאה: {message}',
    columns: {
      recId: 'קוד',
      fundAssetId: 'מספר נייר',
      securityShortName: 'שם קצר',
      buyUnits: "יח' יצירה",
      buyValue: 'שווי יצירה',
      sellUnits: "יח' פדיון",
      sellValue: 'שווי פדיון',
      totalUnits: 'סה"כ יחידות',
      totalValue: 'סה"כ שווי',
      creationPrice: 'מחיר יצירה',
      redemptionPrice: 'מחיר פדיון',
      memberName: 'חבר בורסה',
      memberNumber: "מס' חבר",
      tradeStage: 'שלב מסחר',
      tradeTime: 'מועד',
      crcyId: 'מטבע',
    },
  },
  specialCreationLimits: {
    pageTitle: 'מגבלות יצירה מיוחדות',
    errorPrefix: 'שגיאה: {message}',
    editRow: 'עריכה',
    columns: {
      fundAssetId: 'מספר בורסה',
      fundName: 'שם הקרן',
      limitQty: 'מגבלה בכמות',
      limitValue: 'מגבלה בשווי',
    },
    form: {
      addButton: 'הוספת מגבלה',
      addTitle: 'הוספת מגבלת יצירה מיוחדת',
      editTitle: 'עריכת מגבלת יצירה מיוחדת',
      fund: 'קרן',
      fundSearchPlaceholder: 'חיפוש קרן…',
      limitBy: 'אופן הגדרת המגבלה',
      byQty: 'לפי כמות',
      byValue: 'לפי שווי',
      submit: 'שמור',
      submitting: 'שומר…',
      validationFund: 'יש לבחור קרן',
      validationAmount: 'יש להזין ערך תקין לפי אופן ההגדרה שנבחר',
    },
  },
  configQuanto: {
    pageTitle: 'מדדי קוואנטו',
    errorPrefix: 'שגיאה: {message}',
    columns: {
      recId: 'מזהה',
      symbol: 'סימבול',
      isHardCoded: 'מקודד ידנית',
      secondSymbol: 'סימבול חלופי',
      nonTradingDayFillMethod: 'שיטת השלמה (יום ללא מסחר)',
      nonTradingDayFillOption: 'ערך השלמה',
    },
  },
  crcy: {
    pageTitle: 'מטבעות',
    columns: {
      crcyId: 'קוד',
      crcyName: 'שם מטבע',
      symbol: 'סימבול',
      crcyId4Isa: 'קוד רשות',
      assetId: 'מספר נייר',
      leumiCrcyId: 'קוד מטבע לאומי',
      interestAssetId: 'נייר ריבית',
      crcyName4Isa: 'שם לרשות',
      level3CodeId: 'קוד רובד 3',
      isDirectILSBfix: 'BFIX ישיר מול ש"ח',
    },
    errorPrefix: 'שגיאה: {message}',
  },
  assets: {
    pageTitle: 'ניירות',
    formTitle: 'הגדרת נייר',
    chipAssetNo: 'מס\' נייר',
    source: {
      central: 'נייר כללי',
      tenant: 'נייר של הטננט',
      tenantReadOnlyNote: 'נייר של הטננט — נוצר מתהליך העסקה ואינו ניתן לעריכה במסך זה',
    },
    searchPlaceholder: 'חיפוש נייר',
    noneOption: '— ללא —',
    errorPrefix: 'שגיאה: {message}',
    sections: {
      identity: 'זיהוי הנייר',
      classification: 'סיווג',
      trading: 'מסחר ומטבע',
      benchmarkIndustry: 'ריבית, ענף ומאפיינים',
    },
    columns: {
      assetId: 'קוד נייר',
      assetName: 'שם',
      assetTypeId: 'סוג נייר',
      symbol: 'סימבול',
      crcyId: 'מטבע',
      benchmarkRateId: 'ריבית עוגן',
      benchmarkRatePeriodId: 'תקופת ריבית עוגן',
      expDate: 'תפוגה',
      idxId: 'מדד',
      multiplier: 'כופל',
      value1Point: 'ערך נקודה',
      isForeign: 'זר',
      linkageCrcyId: 'מטבע הצמדה',
      baseAssetTypeId: 'סוג נכס בסיס',
      creditRiskTypeId: 'סוג סיכון אשראי',
      ticker: 'טיקר',
      shortName: 'שם קצר',
      isin: 'ISIN',
      isin4Isa: 'ISIN לרשות',
      bloombergTradePlaceId: 'זירת מסחר בלומברג',
      isPreMarketExchange: 'בורסה מקדימה',
      isDynamicInterest: 'ריבית דינמית',
      countryCode: 'קוד מדינה',
      industryGroupId: 'קבוצת ענף',
      industrySectorId: 'מגזר ענף',
      isGovernment: 'ממשלתי',
      strike: 'מחיר מימוש',
      callOrPut: 'CALL/PUT',
      underlyingAssetId: 'נכס בסיס',
    },
  },
  recordForm: {
    searchPlaceholder: 'חיפוש…',
    existsConfirm: 'רשומה עם מפתח זה כבר קיימת — לטעון את הפרטים?',
    new: 'חדש',
    save: 'שמור',
    saving: 'שומר…',
    saved: 'נשמר',
    newRecord: 'רשומה חדשה',
    noResults: 'אין תוצאות',
    select: 'בחר',
    cancel: 'ביטול',
    close: 'סגור',
    searchTitle: 'חיפוש',
    backToTop: 'חזרה לראש המסך',
    moreActions: 'פעולות נוספות',
    unsavedChanges: 'שינויים לא שמורים',
    unsavedConfirm: 'יש שינויים שלא נשמרו. להמשיך ולאבד אותם?',
    requiredError: 'יש למלא את כל שדות החובה',
    loadError: 'שגיאה בטעינת הרשומה',
    saveError: 'שגיאה בשמירה: {message}',
    none: '— ללא —',
    loading: 'טוען…',
  },
  idx: {
    pageTitle: 'מדדים',
    columns: {
      idxId: 'קוד',
      idxName: 'שם מדד',
      symbol: 'סימבול',
      taseIdxId: 'קוד בורסה',
      idxTypeId: 'סוג מדד',
      crcyId: 'מטבע המדד',
    },
    noneOption: '(ללא)',
    errorPrefix: 'שגיאה: {message}',
  },
  imports: {
    pageTitle: 'קליטה גנרית',
    common: {
      loading: 'טוען...',
      error: 'שגיאה: {message}',
    },
    run: {
      title: 'הרצת קליטה',
      program: 'תוכנית קליטה',
      selectProgram: 'בחר תוכנית…',
      targetTable: 'טבלת יעד',
      mode: 'טיפול בקיימים',
      modeSkip: 'דלג על קיימים',
      modeUpdate: 'עדכן קיימים',
      modeUpdateOnly: 'עדכון בלבד',
      modeUpdateOnlyHint: 'מעדכן רק שורות קיימות; שורות ללא התאמה מדולגות',
      nullLiteralAsEmpty: 'התייחס ל-"NULL" כתא ריק',
      file: 'קובץ לקליטה (CSV / Excel / ZIP)',
      fileHint: 'csv / xlsx / zip',
      runButton: 'הרץ קליטה',
      running: 'מריץ…',
      success: 'הקליטה הושלמה',
      summary:
        'מתוך {total} שורות: {inserted} נוספו, {updated} עודכנו, {skipped} דולגו',
      failed: 'הקליטה בוטלה — לא נשמרו שינויים',
      issuesTitle: 'פירוט שגיאות',
      issueRow: 'שורה',
      issueColumn: 'עמודה',
      issueValue: 'ערך',
      issueReason: 'סיבה',
      noProgramsHint: 'אין תוכניות קליטה פעילות',
      empty: '—',
    },
    define: {
      title: 'הגדרת תוכניות קליטה',
      newProgram: 'תוכנית חדשה',
      noPrograms: 'טרם הוגדרו תוכניות קליטה',
      editorNewTitle: 'תוכנית חדשה',
      editorEditTitle: 'עריכת תוכנית',
      name: 'שם התוכנית',
      targetTable: 'טבלת יעד',
      selectTable: 'בחר טבלה…',
      defaultMode: 'ברירת מחדל לטיפול בקיימים',
      active: 'פעילה',
      inactive: 'לא פעילה',
      columns: 'מיפוי עמודות',
      columnsHint: 'מלא "עמודה בקובץ" רק עבור עמודות שייקלטו',
      colKey: 'מפתח',
      colTarget: 'עמודת יעד',
      colSource: 'עמודה בקובץ',
      source: 'מקור',
      sourceFile: 'מעמודה בקובץ',
      sourceConstant: 'ערך קבוע',
      sourceNone: 'ריק',
      colConstant: 'ערך קבוע',
      colValue: 'ערך / עמודה',
      constantPlaceholder: 'ערך שיוכנס לכל השורות',
      save: 'שמור',
      saving: 'שומר...',
      delete: 'מחק',
      edit: 'ערוך',
      cancel: 'ביטול',
      confirmDelete: 'למחוק את תוכנית הקליטה?',
      requiredMark: 'שדה חובה',
      keyTitle: 'מפתח ראשי',
      nameRequired: 'יש להזין שם תוכנית',
      tableRequired: 'יש לבחור טבלת יעד',
      noMappings: 'יש למפות לפחות עמודה אחת',
    },
  },
  assistant: {
    openTitle: 'פתח את עוזר ה-AI',
    closeTitle: 'סגור את עוזר ה-AI',
    panelTitle: 'עוזר LOP',
    panelSubtitle: 'שואלים בשפה חופשית — תשובות מבוססות על מאגר הידע של המערכת.',
    inputPlaceholder: 'מה אפשר לעשות עבורך?',
    send: 'שלח',
    sending: 'שולח...',
    clear: 'נקה שיחה',
    you: 'אתה',
    assistantLabel: 'עוזר',
    thinking: 'חושב...',
    sourcesLabel: 'מקורות',
    emptyTitle: 'שלום, אני עוזר ה-AI של LOP.',
    emptyHint: 'נסה לשאול: "מה זה רצועה דינמית?" או "איך מגדירים נייר במערכת?"',
    errorPrefix: 'שגיאה: ',
    keyboardHint: 'Ctrl+\\ לפתיחה/סגירה',
    usageTooltip: 'קלט: {input} • פלט: {output} • קטעים: {chunks}',
    likeTooltip: 'התשובה הייתה מועילה',
    dislikeTooltip: 'התשובה לא הייתה מועילה',
  },
  assistantLog: {
    pageTitle: 'יומן עוזר AI',
    columns: {
      loggedAt: 'מועד',
      user: 'משתמש',
      route: 'מסך',
      question: 'שאלה',
      answer: 'תשובה',
      chunks: 'קטעים',
      inputTokens: 'קלט',
      outputTokens: 'פלט',
      feedback: 'דירוג',
      error: 'שגיאה',
    },
  },
  dayOpen: {
    pageTitle: 'פתיחת יום',
    subtitle: 'מצב וביצוע פתיחת יום לכל חברת ניהול',
    openAllReady: 'פתח לכולם',
    confirmOpenAll: 'לבצע פתיחת יום לכל הטננטים?',
    bankData: 'קליטת בנקים אחרונה',
    dataOf: 'נתוני',
    noBankImport: 'לא נקלטו קבצים',
    dayStatus: 'סטטוס יום',
    open: 'פתוח',
    closed: 'סגור',
    lastOpen: 'פתיחה אחרונה',
    by: 'ע"י',
    runButton: 'בצע פתיחה',
    running: 'מבצע...',
    loadError: 'שגיאה בטעינת סטטוס',
    noTenants: 'אין חברות ניהול להצגה',
    openAllNoneReady: 'אין חברות ניהול לפתיחה',
    openAllResult: 'בוצעו {ok} פתיחות, {failed} נכשלו',
    inProgress: 'פתיחת יום בתהליך…',
    queued: 'פתיחת יום ממתינה בתור…',
    elapsed: 'זמן שחלף',
    lastDuration: 'משך פתיחה אחרונה',
    lastDurationFailed: 'נכשלה',
    minutesAbbr: "דק'",
    runFailed: 'פתיחת היום נכשלה',
    runSucceeded: 'פתיחת היום הושלמה',
    alreadyRunning: 'פתיחת יום כבר רצה עבור החברה הזו',
    params: {
      titleSingle: 'פתיחת יום — {tenant}',
      titleAll: 'פתיחת יום — כל המוכנים',
      israeli: 'שיערוך ישראלים',
      foreign: 'שיערוך זרים',
      valuationDate: 'תאריך שיערוך',
      valuationType: 'סוג שיערוך',
      validation: 'יש לבחור תאריך וסוג שיערוך לישראלים ולזרים',
      confirm: 'פתח יום',
    },
    confirm: {
      title: 'פתיחת יום — לא בוצעו כל הפעולות המקדימות',
      text: 'האם אתה בטוח שברצונך לפתוח את היום? לא בוצעו כל הפעולות המקדימות לפתיחת יום:',
      proceed: 'פתח יום בכל זאת',
      agendaItem: 'אג׳נדה: {name}',
      bankItem: 'קליטת בנק: {name} ({status})',
      checkFailed: 'לא ניתן היה לאמת את הפעולות המקדימות',
    },
  },
  bankImportLog: {
    pageTitle: 'היסטוריית קליטות',
    seconds: '{n} שנ׳',
    minutes: '{n} דק׳',
    status: {
      running: 'רצה',
      success: 'הצליחה',
      failed: 'נכשלה',
    },
    columns: {
      startedAt: 'תחילת הקליטה',
      status: 'סטטוס',
      importName: 'הקליטה',
      bankId: 'בנק',
      valueDate: 'תאריך נכונות',
      duration: 'משך',
      filesReceived: 'קבצים שנשלחו',
      filesLoaded: 'קבצים שנטענו',
      rowsLoaded: 'שורות שנקלטו',
      fileNames: 'שמות הקבצים',
      filePattern: 'תבנית קובץ',
      messages: 'הודעות',
      createdBy: 'מי הריץ',
    },
  },
  auditLog: {
    pageTitle: 'יומן פעולות',
    columns: {
      loggedAt: 'מועד',
      user: 'משתמש',
      resourceCode: 'מסך',
      operation: 'פעולה',
      entityKey: 'מפתח',
      fundId: 'קרן',
      assetId: 'נייר',
      tenantId: 'חברה',
      oldValue: 'ערך ישן',
      newValue: 'ערך חדש',
      note: 'הערה',
      via: 'מקור',
    },
    via: {
      ui: 'מסך',
      assistant: 'עוזר AI',
      system: 'מערכת',
    },
  },
  pageViewLog: {
    pageTitle: 'שימוש במסכים',
    columns: {
      pageCode: 'קוד מסך',
      displayName: 'שם המסך',
      url: 'נתיב',
      lastUsedAt: 'נצפה לאחרונה',
      daysIdle: 'ימים מאז',
      totalViews: 'סך צפיות',
      distinctUsers: 'משתמשים שונים',
    },
    never: '(אף פעם)',
    none: '—',
  },
  bankFiles: {
    pageTitle: 'קליטת קבצים',
    accessDenied: 'אין לך הרשאה לצפות במסך זה',
    selectFolder: 'בחר תיקייה / קבצים:',
    filesSelected: '{count} קבצים נבחרו',
    chooseFolder: 'בחר תיקייה',
    chooseFile: 'בחר קובץ (אפשר גם ZIP)',
    noFileChosen: 'לא נבחר קובץ',
    valueDateLabel: 'תאריך נכונות:',
    uploadButton: 'העלה וקלוט',
    uploading: 'קולט...',
    uploadingElapsed: 'קולט... {elapsed} שנ׳',
    uploadingHint: 'הקליטה בעבודה — נא לא לסגור את המסך',
    resultDuration: 'משך הקליטה: {elapsed} שנ׳',
    uploadSuccess: 'הקליטה הסתיימה בהצלחה',
    uploadNothingLoaded: 'הקליטה לא טענה אף קובץ',
    lastImportDate: 'קליטה אחרונה: {date}',
    resultFilesLoaded: 'קבצים שנטענו: {count}',
    resultPreInventoryRows: 'שורות פרה-מלאי: {count}',
    resultValueDates: 'תאריכי ערך: {dates}',
    preInventoryTitle: 'פרה-מלאי',
    filterBankLabel: 'בנק:',
    filterDateLabel: 'תאריך ערך:',
    filterFetchButton: 'שלוף',
    exceptions: {
      title: 'חריגי קליטה',
      valueDate: 'תאריך נכונות',
      exceptionCode: 'קוד חריגה',
      severity: 'חומרה',
      message: 'הודעה',
      details: 'פירוט',
      createdAt: 'נוצר בתאריך',
      severity1: 'מידע',
      severity2: 'אזהרה',
      severity3: 'שגיאה',
      allBanks: 'כל הבנקים',
      none: 'אין חריגי קליטה',
    },
    grid: {
      acc: 'חשבון',
      balanceCode: 'קוד יתרה',
      assetId: 'מספר נייר',
      assetName: 'שם נייר',
      qty: 'כמות',
      qty4Receive: 'יתרה לקבל',
      crcyId: 'מטבע',
      rate: 'שער',
      noseType: 'מקור',
      splitterCode: 'מפצל',
      valueDate: 'תאריך',
    },
  },
  devTools: {
    menuTitle: 'פיתוח והטמעה',
    tools: {
      parseFiles: 'פרסור קבצים',
    },
    parseFiles: {
      pageTitle: 'פרסור קבצים',
      subtitle: 'כלי לצפייה בפרסור קובץ בנק גולמי — מריץ אותו דרך המתאם הקיים ומציג את השורות המפורסרות. קריאה בלבד, לא קולט דבר.',
      fileTypeLabel: 'סוג קובץ',
      fileTypes: {
        poalim: 'פועלים',
        leumi: 'לאומי',
        mizrahi: 'מזרחי',
        discountYit: 'דיסקונט YIT',
        discountYth: 'דיסקונט YTH',
        discountDtak: 'דיסקונט DTAK',
      },
      fileLabel: 'קובץ',
      parseButton: 'פרסר',
      parsing: 'מפרסר...',
      rowCount: '{count} שורות',
    },
  },
  tabs: {
    ariaLabel: 'טאבים פתוחים',
    home: 'דף הבית',
    close: 'סגור טאב',
    closeOthers: 'סגור את השאר',
    closeAll: 'סגור הכל',
    maxTabsReached: 'הגעת למספר הטאבים המקסימלי',
    switcherAriaLabel: 'החלפת טאבים',
    unsavedConfirm: 'לטאב הזה יש שינויים שלא נשמרו. לסגור ולאבד אותם?',
    capModalExplanation: 'יש לסגור מספר טאבים על מנת לפתוח חדשים',
    capModalCounter: '{count} / {max}',
    capModalConfirm: 'אישור',
    capModalCancel: 'ביטול',
  },
  userGuide: {
    title: 'מדריך למשתמש',
    open: 'מדריך למשתמש',
    downloadPdf: 'הורדת PDF',
    downloadPdfHint: 'נפתח חלון ההדפסה — יש לבחור "שמירה כ-PDF"',
    preparingPdf: 'מכין PDF...',
    tocAriaLabel: 'תוכן עניינים',
    loading: 'טוען את המדריך...',
    loadError: 'לא ניתן לטעון את המדריך כרגע.',
    retry: 'נסו שוב',
    chapterUnavailable: 'תוכן הפרק אינו זמין כרגע.',
    previous: 'הקודם',
    next: 'הבא',
    chapterNav: 'ניווט בין פרקים',
    chapterNumberLabel: 'פרק {number}',
    asOf: 'נכון ל-{date}, גרסה {version}',
    tocPageTitle: 'תוכן עניינים',
    emptyChapter: 'אין תוכן בפרק זה.',
  },
  legacyRatesImport: {
    pageTitle: 'קליטת שערים מהלגאסי',
    explanation:
      'מקור זמני: עד שיהיו ללוף פידים משלו, מריצים בלגאסי את שאילתת הייצוא (כל כמה שעות), ואת הפלט הטקסטואלי מדביקים כאן או טוענים כקובץ. הקליטה היא הכול-או-כלום: שורה פגומה אחת דוחה את כל הקלט ולא נכתב דבר.',
    exportQuery: 'הורדת שאילתת הייצוא ללגאסי',
    sample: 'קובץ לדוגמה',
    textLabel: 'הדבקת פלט השאילתה',
    textPlaceholder: 'הדביקו כאן את פלט השאילתה (שורה לכל רשומה, מופרד ב-|)',
    chooseFile: 'בחרו קובץ טקסט או גררו לכאן',
    dropHint: 'txt / csv / tsv / zip — במקום ההדבקה',
    replaceFile: 'לחצו להחלפה',
    clearFile: 'ניקוי הקובץ',
    run: 'קלוט',
    running: 'קולט...',
    lineCount: '{count} שורות',
    resultTitle: 'תוצאת הקליטה',
    comparisonLines: 'שורות השוואה — לא נקלטו',
    genericError: 'הקליטה נכשלה.',
    downloadError: 'ההורדה נכשלה.',
    types: {
      R: 'שערים נוכחיים',
      H: 'שערי סגירה',
      M: 'מדדים נוכחיים',
      N: 'היסטוריית מדדים',
      C: 'שערי מט"ח',
      S: 'שערים מיוחדים',
    },
    dates: {
      effectiveOpenDate: 'תאריך פתיחה (ישראלים)',
      zarimShiaruchDate: 'תאריך שיערוך זרים',
      fxDate4Israeli: 'תאריך מט"ח לישראלים',
      prevBusinessDate: 'יום עסקים קודם',
      bursaRegilaDate: 'בורסה רגילה',
      bursaMakdimaDate: 'בורסה מקדימה',
      typeIsr: 'סוג שיערוך ישראלים',
      typeZar: 'סוג שיערוך זרים',
    },
    cols: {
      type: 'סוג',
      received: 'התקבלו',
      inserted: 'נוספו',
      updated: 'עודכנו',
      skipped: 'דולגו',
    },
    issues: {
      line: 'שורה',
      reason: 'סיבה',
    },
    log: {
      title: 'קליטות אחרונות',
      when: 'מתי',
      by: 'על ידי',
      source: 'מקור',
      lines: 'שורות',
      legacyDates: 'תאריכי לגאסי',
      result: 'תוצאה (נוספו/עודכנו/דולגו)',
      compactItem: '{type}: +{inserted} ~{updated} -{skipped}',
      empty: 'עדיין לא בוצעו קליטות.',
      error: 'טעינת יומן הקליטות נכשלה.',
    },
  },
  swapUf: {
    pageTitle: 'ניהול SWAP UF',
    filters: {
      fund: 'קרן',
      allFunds: 'כל הקרנות',
      acc: 'חשבון',
      allAccounts: 'כל החשבונות',
      assetId: 'מספר נייר',
      includeSettled: 'כולל עסקאות שנסלקו',
    },
    actions: {
      newSwap: 'SWAP חדש',
      importFile: 'קליטת קובץ עסקאות',
      exceptions: 'חריגים',
    },
    contextMenu: {
      adjust: 'הגדלה / הקטנה בחשבון זה',
    },
    direction: {
      increase: 'הגדלה',
      decrease: 'הקטנה',
    },
    action: {
      new: 'עסקה חדשה',
      increase: 'הגדלה',
      decrease: 'הקטנה',
    },
    side: {
      Buy: 'קנייה',
      Sell: 'מכירה',
    },
    columns: {
      acc: 'חשבון',
      fundAssetId: 'מספר קרן',
      fundName: 'שם קרן',
      assetId: 'מספר נייר',
      assetName: 'שם נייר',
      swapStatusName: 'סטטוס',
      isReset: 'ריסט',
      direction: 'כיוון',
      qty: 'כמות',
      idxName: 'מדד',
      dealDate: 'תאריך עסקה',
      dealIdxRate: 'שער מדד בעסקה',
      resetDate: 'תאריך ריסט',
      resetIdxRate: 'מדד ריסט',
      lastIdxRate: 'שער מדד אחרון',
      interestUsed: 'ריבית',
      spreadPercent: 'מרווח',
      buyFeePercent: 'עמלת קנייה',
      sellFeePercent: 'עמלת מכירה',
      mtm: 'MTM',
      mgm: 'MGM',
      valuationDate: 'תאריך שיערוך',
      unknownReason: 'סיבת אי-ידיעה',
      createdBy: 'נוצר ע"י',
    },
    notice: {
      created: 'נוצר נייר SWAP מספר {assetId}',
      closing: 'הקטנה מלאה — העסקה נסגרת',
      dismiss: 'סגור',
    },
    modal: {
      close: 'סגור',
      cancel: 'ביטול',
      loadError: 'טעינת הנתונים נכשלה',
    },
    create: {
      title: 'יצירת SWAP UF',
      action: 'פעולה',
      actionNew: 'עסקה חדשה',
      actionIncrease: 'הגדלה',
      actionDecrease: 'הקטנה',
      account: 'חשבון',
      accountNewHint: 'חשבונות ללא שרשרת פעילה',
      accountAdjustHint: 'חשבונות עם שרשרת פעילה',
      pickAccount: 'בחר חשבון',
      dealDate: 'תאריך עסקה',
      qty: 'כמות',
      long: 'לונג',
      short: 'שורט',
      index: 'מדד',
      baseIdxRate: 'שער המדד בתאריך העסקה',
      buyFee: 'עמלת קנייה %',
      sellFee: 'עמלת מכירה %',
      dealIdxRate: 'שער מדד בעסקה (כולל עמלה)',
      forceDealIdx: 'אילוץ ערך',
      fxRatio: 'יחס מטבע בעסקה',
      crcy: 'מטבע ה-SWAP',
      assetType: 'סוג נכס',
      interestType: 'סוג ריבית',
      fixedRate: 'ריבית קבועה %',
      interestAsset: 'נייר ריבית',
      interestAssetPick: 'בחירת נייר ריבית',
      spread: 'מרווח %',
      settlementCrcy: 'מטבע סליקה',
      settlementDays: 'ימי סליקה',
      preMarket: 'בורסה מקדימה',
      resetFrequency: 'תדירות ריסט (חודשים)',
      assetName: 'שם נייר',
      ticker: 'טיקר',
      autoCreated: 'ייווצר אוטומטית',
      chainInfo: 'כמות פתוחה בעסקה: {qty} | תאריך ריסט: {resetDate}',
      noHistory: 'לחשבון אין היסטוריית SWAP — יש למלא את השדות ידנית',
      loadingDefaults: 'טוען ברירות מחדל...',
      save: 'צור',
      saving: 'שומר...',
      qtyInvalid: 'יש להזין כמות חיובית',
      accInvalid: 'יש לבחור חשבון',
      dateInvalid: 'יש להזין תאריך עסקה',
      assetColId: 'מספר נייר',
      assetColName: 'שם נייר',
      assetColSymbol: 'סימול',
    },
    import: {
      title: 'קליטת עסקאות SWAP מקובץ',
      explanation:
        'קובץ העסקאות היומי של Beta. נקלטות שורות SWAP בלבד; חוזים עתידיים מתעלמים.',
      sample: 'קובץ לדוגמה',
      sampleError: 'הורדת קובץ הדוגמה נכשלה',
      file: 'קובץ (.xlsx / .zip)',
      chooseFile: 'בחירת קובץ Beta',
      dropHint: 'לחצו לבחירה או גררו לכאן קובץ xlsx או zip',
      replaceFile: 'לחצו או גררו קובץ אחר להחלפה',
      run: 'קלוט',
      running: 'קולט...',
      summary: 'נקלטו {created} | חריגים {exceptions} | כפולות {duplicates} מתוך {total} שורות',
      statTotal: 'שורות SWAP בקובץ',
      statCreated: 'נקלטו',
      statExceptions: 'לחריגים',
      statDuplicates: 'כפולות',
      colRowNo: 'שורה',
      colFundNumber: 'מספר קרן',
      colFundName: 'שם קרן',
      colTicker: 'טיקר',
      colSide: 'צד',
      colQty: 'כמות',
      colAcc: 'חשבון',
      colAction: 'פעולה',
      colStatus: 'סטטוס',
      colReason: 'סיבה',
    },
    status: {
      created: 'נקלט',
      exception: 'חריג',
      duplicate: 'כפול',
      resolved: 'שויך',
      dismissed: 'בוטל',
    },
    exceptions: {
      title: 'חריגי קליטה',
      empty: 'אין חריגים פתוחים',
      colDate: 'תאריך ביצוע',
      colAccountRaw: 'חשבון בקובץ',
      pickAccount: 'בחר חשבון',
      assign: 'שייך',
      dismiss: 'בטל שורה',
      dismissConfirm: 'לבטל את שורת החריג? הפעולה אינה הפיכה.',
      noFund: 'אין קרן מזוהה',
      colActions: 'פעולות',
    },
  },
  manualBalances: {
    pageTitle: 'תוספת יתרות ידנית לשיערוך',
    sample: 'קובץ לדוגמה',
    sampleError: 'הורדת קובץ הדוגמה נכשלה',
    errorPrefix: 'שגיאה: {message}',
    counts: {
      total: 'סה"כ {n}',
      valid: 'תקינות {n}',
      invalid: 'לא תקינות {n}',
    },
    errIncomplete: 'שורה {n}: חובה למלא חשבון, נייר וקוד יתרה',
    importFile: 'קליטה מקובץ',
    importHint: 'קובץ אקסל (.xlsm / .xlsx) - הקליטה מחליפה את כל הרשימה',
    importReplaceHint: 'לחצו להחלפת הקובץ',
    importClear: 'נקה בחירה',
    addRow: 'הוסף שורה',
    save: 'שמור',
    onlyInvalid: 'רק שורות לא תקינות',
    confirmTitle: 'קליטה מקובץ',
    confirmText: 'הקליטה תחליף את כל הרשימה הנוכחית ({count} שורות). להמשיך?',
    confirmProceed: 'המשך וקלוט',
    confirmCancel: 'ביטול',
    saveReplacesNote: 'השמירה מחליפה את כל הרשימה ומעבירה את השורות התקינות למלאי',
    summary: 'גיליון {sheetName} · נקראו {rowsRead} · דולגו {skipped} ריקות · תקינות {valid} · לא תקינות {invalid} · נכנסו למלאי {pushed}',
    summarySave: 'נשמרו {total} שורות · תקינות {valid} · לא תקינות {invalid} · נכנסו למלאי {pushed}',
    importError: 'הקליטה נכשלה',
    unsavedWarning: 'יש שינויים שלא נשמרו. הקליטה מקובץ תדרוס אותם.',
    status: {
      ok: 'נקלט תקין',
      pending: 'טרם נשמר',
    },
    searchAsset: 'חיפוש נייר',
    deleteRow: 'מחק שורה',
    columns: {
      status: 'סטטוס',
      acc: 'חשבון',
      fundName: 'קרן',
      assetId: 'נייר',
      assetName: 'שם נייר',
      balanceTypeId: 'קוד יתרה',
      qty: 'כמות',
      qty4Receive: 'יתרה לקבל',
      expirationDate: 'תאריך תפוגה',
      executionDate: 'תאריך ביצוע',
      remark: 'הערה',
      enteredBy: 'הוזן ע"י',
      isTransferInProcess: 'העברה בתהליך',
      actions: 'פעולות',
    },
  },
} as const;

export type Messages = typeof messages;
